import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M10.092 12.039a1.48 1.48 0 0 0 2.033.185l2.263-1.847c.273-.222.688-.015.665.333l-.154 2.27c-.042.422-.25.815-.584 1.087L9.843 17.71l5.64-1.088c1-.192 1.891-.747 2.498-1.552l3.22-4.52M18.178 6.042c-1.084.189-2.806.676-3.832 1.065"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M12.583 6.17C8.94 6.534 8.72 8.5 9.77 9.574c.954.975 2.99-.536 1.61-2.288-.753-.956-2.306-2.04-3.251-1.27l-.834.68c-.33.269-.8.03-.86-.343a1.6 1.6 0 0 0-.358-.767 1.666 1.666 0 0 0-2.405-.136 1.6 1.6 0 0 0-.196 2.115c.207.28.48.472.784.578.36.124.499.615.176.88l-1.779 1.45a1.295 1.295 0 0 0-.177 1.843l1.265 1.495c.265.317-.062.759-.404.82a1.65 1.65 0 0 0-.75.343 1.6 1.6 0 0 0-.134 2.364c.554.566 1.457.66 2.118.215.322-.219.537-.52.641-.857.104-.325.561-.487.811-.193l1.31 1.556a1.35 1.35 0 0 0 1.876.174l5.103-4.158c.334-.272.545-.664.584-1.087l.153-2.27c.023-.351-.392-.559-.664-.332l-2.264 1.847a1.48 1.48 0 0 1-2.032-.186"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M14.316 14.074c.334-.272.545-.664.584-1.087l.153-2.27c.023-.351-.392-.559-.665-.332l-2.263 1.846a1.48 1.48 0 0 1-2.033-.185"
    />
  </svg>
);
export const PuzzleIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
